import React from 'react'

export const FirstButton: React.CSSProperties = {
  marginTop: 0,
}
